import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { delay } from 'rxjs/operators';
import { ConfigProvider } from "../../../config-provider.service";
import { BreadcrumbBreadcrumbComponent } from "../../../breadcrumb/components/breadcrumb/breadcrumb";
import { FullWidthLoaderComponent } from "../full-width-loader/full-width-loader";
import { NgIf } from "@angular/common";
import { LoadingService } from "../../providers/loading.service";

@Component({
  selector: 'page-content',
  providers: [],
  styleUrls: ['./page-content.scss'],
  standalone: true,
  imports: [
    BreadcrumbBreadcrumbComponent,
    FullWidthLoaderComponent,
    NgIf
  ],
  templateUrl: './page-content.html'
})
export class PageContentComponent implements OnInit {
    @Input() public fullPageWidth = false;
    @Input() public hasHeader = true;

    public loading = false;

    constructor(
        public conf: ConfigProvider,
        private _translater: TranslateService,
        private _loading: LoadingService
    ) {
    }

    public ngOnInit(): void {
        this.listenToLoading();
    }

    /**
     * Listen to the loadingSub property in the LoadingService class. This drives the
     * display of the loading spinner.
     */
    private listenToLoading(): void {
        this._loading.loadingSub
            .pipe(delay(0)) // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
            .subscribe((loading: boolean) => {
                this.loading = loading;
            });
    }
}
